import React from 'react';

import clsxm from '@/lib/clsxm';

import Icon from './Icon';

export type IconCircleProps = {
  icon: string;
  iconClassName?: string;
  iconWidth?: number;
  iconHeight?: number;
  className?: string;
};

const IconCircle: React.FC<IconCircleProps> = (props) => (
  <div
    className={clsxm(
      'flex h-24 w-24 items-center justify-center rounded-full bg-ds-grey-50 p-8',
      props.className
    )}
  >
    <Icon
      name={props.icon}
      className={props.iconClassName}
      width={props.iconWidth}
      height={props.iconHeight}
    />
  </div>
);

export default IconCircle;
